import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"
import _imports_0 from '../../assets/img/bobbee_hrz.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_profile_menu = _resolveComponent("profile-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.isRoot)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        raw: "",
        fluid: "",
        xs12: "",
        style: {"margin":"0","padding":"0"},
        transition: "scroll-x-transition"
      }, {
        default: _withCtx(() => [
          (_ctx.currentUser && _ctx.currentUser.profile && _ctx.$route.name !== 'maintenance')
            ? (_openBlock(), _createBlock(_component_v_app_bar, {
                key: 0,
                app: "",
                "clipped-left": "",
                flat: "",
                class: "pa-0 ma-0",
                color: !_ctx.$vuetify.display.mobile ? 'transparent' : 'primary',
                dense: _ctx.$vuetify.display.mobile
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_app_bar_title, {
                    style: {"max-width":"256px"},
                    color: "transparent",
                    class: "d-flex justify-center align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _ctx.logoBobbeeMini,
                        height: "40px"
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    color: "white",
                    class: "fill-height bg-white rounded-bs-xl px-8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "7",
                        class: "d-flex align-center"
                      }),
                      _createVNode(_component_v_col, {
                        cols: "5",
                        class: "d-flex align-center justify-end"
                      }, {
                        default: _withCtx(() => [
                          (
                            _ctx.currentUser &&
                            _ctx.currentUser.profile &&
                            _ctx.currentUser.profile.configuration.internalManagement.access
                        )
                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                key: 0,
                                icon: "$oss-outlined-home",
                                color: "primary",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accoutantHome())),
                                style: _normalizeStyle(_ctx.topButtonStyle)
                              }, null, 8, ["style"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_profile_menu)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["color", "dense"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_navigation_drawer, {
            color: "primary",
            app: "",
            clipped: "",
            flat: "",
            floating: "",
            class: "navigation rounded-te-xl d-flex"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "d-flex justify-end align-end text--primary px-1"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" by ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "9",
                    class: "d-flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _imports_0,
                        height: "30px"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (!_ctx.isAccountingEmployee)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'controlCenterDashboard' })))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("$fa-home")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("Dashboard")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isAccountingEmployee)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'controlCenterAPI' })))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("$fa-user-cog")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("API")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_main, {
            raw: "",
            fluid: "",
            xs12: "",
            class: "background_image d-flex align-start fill-height",
            style: {"width":"100%","margin":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_Transition, {
                name: "slide-fade",
                class: "fill-height"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view, {
                    transition: "scroll-x-transition",
                    class: "fill-height"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}